<template>
    <div class="portrait-tag-wrap">
        <div class="class-panel">
            <div class="class-title">画像标签管理</div>
            <el-input v-model="searchName" placeholder="搜索分类" suffix-icon="el-icon-search" @change="getClassData" />
            <div class="all-tag">
                <span @click="allTagClick"
                    >全部标签<em>({{ tagTotal }})</em></span
                >
                <TagEdit :data="{ type: 'add', tagData: { useType: [] } }" @submit="getClassData">
                    <el-button slot="dialogBtn" class="el-icon-plus" size="mini"> 新增分类</el-button>
                </TagEdit>
            </div>
            <TagList v-if="tagTotal" :data="tagData" :select-id="currentClassId" @click="tagClick" @change="getClassData" />
            <div v-else class="tag-tip">
                <span>请创建标签分类</span>
            </div>
        </div>
        <div class="params-panel">
            <SimpleTablePage
                :pageTitle="tagClassName"
                :columns="columns"
                :pageLength="listInfo.size"
                :pageLengthRank="pageLengthRank"
                :total="listInfo.total"
                :dataset="listInfo.list"
                :filters="searchFilter"
                :filterInit="search"
                :operationBtns="operationBtns"
                :footerOperationBtns="bottomButtons"
                :isHideFooter="false"
                @filterChange="filterFieldsChange"
                @pageChange="pageChange"
                @columnClick="columnClick"
                @bottomClick="bottomClick"
                @selectionChange="selectionChange"
            >
                <span class="sp-describe" slot="describe">
                    (共<span>{{ listInfo.total }}</span> 条标签，<span>{{ listInfo.enableCount }}</span
                    >条已启用，<span>{{ listInfo.noEnableCount }}</span
                    >条未启用)
                </span>
            </SimpleTablePage>
        </div>
    </div>
</template>

<script>
import TagList from "./components/TagList.vue";
import TagEdit from "./components/TagEdit.vue";
import TagModal from "./components/TagModal.vue";
import SimpleTablePage from "@/views/zhiji/templates/simpleTablePage/index.vue";
import { columns, pageLengthRank, searchFilter, bottomButtons } from "./config";
import { queryTagClassList, queryTagList, delTag, changeStatusTag } from "./server";
import { queryParamsList } from "../portraitParams/server"

export default {
    name: "portraitTags",
    components: {
        TagList,
        TagEdit,
        SimpleTablePage
    },
    data() {
        return {
            searchName: "",
            tagData: [],
            tagTotal: 0,
            currentClassId: "", // 选中标签分类id
            search: {
                filterFields: {
                    params: this.$route.params.ids, // 参数id
                    status: "",
                    keyWordSearch: {
                        type: "name",
                    }
                }
            },
            listInfo: {
                list: [],
                total: 0,
                enableCount: 0, //启用状态数量
                notEnableCount: 0, //未启用状态数量
                page: 1,
                size: 10,
                status: "start" // 'start' //初始状态 'loading' 加载中,'loadingend' 加载完成
            },
            isCheckAll: false,
            checkArr: [], // 选中的数据
            operationBtns: [
                {
                    text: "添加标签",
                    type: "primary",
                    round: true,
                    onClick: this.addTag,
                }
            ],
            columns,
            pageLengthRank,
            bottomButtons,
            tagClassName: "全部标签",
            paramOptions: [] // 画像参数下拉项
        };
    },
    computed: {
        searchFilter(){
            // 取对应的参数下拉项
            return searchFilter({ params: this.paramOptions });
        },
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        },
        hasParamIds() {
            return this.$route.params.ids;
        },
    },
    mounted() {
        this.getClassData();
        this.getparamOptions();
        this.getList();
    },
    methods: {
        async getClassData() {
            const { list, count } = await queryTagClassList({
                gameId: this.gameId,
                name: this.searchName,
            });
            this.tagData = list;
            this.tagTotal = count;
        },
        async getList() {
            const { page, size, status } = this.listInfo;
            if (status === "loading") {
                return;
            }
            const { list, count, enableCount, noEnableCount } = await queryTagList({
                page,
                size,
                currentClassId: this.currentClassId,
                gameId: this.gameId,
                ...this.search.filterFields,
            });

            this.listInfo.list = list;
            this.listInfo.total = count;
            this.listInfo.enableCount = enableCount;
            this.listInfo.noEnableCount = noEnableCount;
            this.listInfo.status = "loadingend";
            this.checkArr = [];
            this.isCheckAll = false;
        },
        async getparamOptions() {
            const { list = [] } = await queryParamsList({ gameId: this.gameId });
            this.paramOptions = list.map(item => ({ label: item.name, value: item.id }));
        },
        filterFieldsChange({ filterFields }) {
            this.search.filterFields = filterFields;
            this.getList();
        },
        pageChange(data) {
            const { curPage, pageLength } = data;
            this.listInfo.page = curPage;
            this.listInfo.size = pageLength;
            this.getList();
        },
        columnClick({ rowData, originEvent }) {
            // 表格操作按钮触发事件
            if (originEvent.value === "cope") {
                // 复制弹窗
                this.$store.dispatch("zhiji/showModal", {
                    type: TagModal,
                    data: {
                        title: "复制为新的参数封装标签",
                        classId: rowData.classify_id.toString(), // 选中标签分类
                        name: rowData.name,
                        describe: rowData.describe,
                        paramJson: rowData.param_json,
                        submit: async () => {
                            this.getList();
                        }
                    }
                });
            } else if (originEvent.value === "on") {
                // 启用
                this.changeStatusTag(1, rowData.id);
            } else if (originEvent.value === "off") {
                // 停用
                this.changeStatusTag(0, rowData.id);
            } else if (originEvent.value === "del") {
                // 删除
                this.deletetTags(rowData.id);
            } else if (originEvent === "successEdit") {
                // 编辑标签后刷新
                this.getList()
            }
        },
        bottomClick({ data }) {
            // 表格底部批量操作按钮触发事件
            if (this.checkArr.length === 0) {
                this.$confirm("请选择一条标签!", "提示", {
                    distinguishCancelAndClose: true,
                    type: "warning",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                });
                return;
            }
            if (data.id === "del") {
                // 批量删除
                this.deletetTags();
            } else if (data.id === "online") {
                // 批量上线
                this.changeStatusTag(1, this.checkArr.join());
            } else if (data.id === "offline") {
                // 批量下线
                this.changeStatusTag(0, this.checkArr.join());
            }
            // 批量操作
        },
        selectionChange(data) {
            // 存选中id
            this.checkArr = data.map(item => item.id);
        },
        allTagClick() {
            // 所有分类
            this.currentClassId = "";
            this.tagClassName = "全部标签";
            this.getList();
        },
        tagClick(data) {
            this.currentClassId = `${data.id}`;
            this.tagClassName = data.name;
            this.getList();
        },
        deletetTags(id) {
            this.$confirm("您确认删除该画像参数吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    delTag({
                        gameId: this.gameId,
                        ids: id || this.checkArr.join()
                    }).then(() => {
                        this.getList();
                    });
                })
                .catch();
        },
        async changeStatusTag(status, ids) {
            // 批量设置标签状态
            await changeStatusTag({
                gameId: this.gameId,
                ids,
                status,
            });
            this.getList();
        },
        addTag() {
            // 新增参数封装标签
            this.$store.dispatch("zhiji/showModal", {
                type: TagModal,
                data: {
                    title: "新增参数封装标签",
                    classId: this.currentClassId, // 选中标签分类
                    submit: async () => {
                        this.getList();
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.portrait-tag-wrap {
    display: flex;
    height: 100%;
    /deep/.el-icon-search {
        &::before {
            position: relative;
            right: 0;
            top: 7px;
            cursor: pointer;
        }
    }
    .class-panel {
        position: relative;
        width: 272px;
        box-sizing: border-box;
        border-right: 1px solid #e3ecf5;
        background: #f2f7fb;
        overflow-x: hidden;
        overflow-y: auto;
        .class-title {
            font-size: 16px;
            font-weight: 600;
            color: #41475e;
            margin: 16px;
        }
        .el-input {
            margin: 16px 16px 8px 16px;
            width: auto;
            display: flex;
        }
        .all-tag {
            position: relative;
            display: flex;
            align-items: center;
            padding: 12px 16px;
            font-size: 12px;
            justify-content: space-between;
            cursor: pointer;
            &:after {
                content: "";
                position: absolute;
                left: 16px;
                bottom: 0;
                right: 0;
                margin: 0 auto;
                width: calc(100% - 32px);
                height: 1px;
                display: inline-block;
                background: #e3edf6;
            }
            span {
                font-weight: bold;
                flex: 1;
            }
            em {
                color: #9b9ba3;
            }
            .el-button {
                padding: 0 4px;
            }
            &:hover {
                background: rgba(217, 235, 246, 0.7);
            }
            .el-icon-plus {
                width: 82px;
                height: 28px;
                color: #7a7f8f;
                cursor: pointer;
            }
        }
        .tag-tip {
            padding: 16px 26px;
            span {
                display: block;
                text-align: center;
                margin-bottom: 12px;
            }
            p {
                color: #ff782b;
            }
        }
    }
    .params-panel {
        flex: 1;
        background: #fff;
        // padding: 0 24px 0 24px;
        border-radius: 4px;
        overflow-x: hidden;
        overflow-y: auto;

        .sp-describe {
            font-weight: normal;
            margin-left: 24px;
            font-size: 14px;
            span {
                color: #26d485;
            }
        }
        .top-operate {
            margin-bottom: 5px;
        }
        .notice {
            color: #ff782b;
            margin-bottom: 15px;
        }
        .top-right {
            display: flex;
        }
        .search-input {
            width: 380px;
        }
        .search-select {
            width: 130px;
            /deep/.el-input {
                border: 1px solid transparent;
            }
            /deep/.is-focus {
                border-color: #2088f3;
                transition: none;
                box-sizing: border-box;
                border-radius: 4px;
            }
            /deep/.el-input__inner {
                color: #606266;
                border: none;
                height: 30px;
                line-height: 30px;
            }
        }
        .bottom-panel {
            .el-checkbox {
                margin-right: 15px;
            }
        }
        .edit-link {
            font-size: 12px;
        }
        /deep/.el-icon-circle-close:before {
            color: #cbcfd5;
        }
    }
    /deep/.el-table {
        .check-column {
            padding-left: 10px;
        }
    }
}
</style>
